<template>
  <div class="app-container">
    <app-sidebar/>
    <main class="main-content">
      <app-header/>
      <div :class="pageClass" class="page-container">
        <slot/>
      </div>
    </main>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppSidebar from "@/components/AppSidebar.vue";

export default {
  name: "Main",
  components: {
    AppHeader,
    AppSidebar
  },
  props: {
    pageClass: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/views/Main.vue